import React, {createRef, ReactNode} from 'react';
import {TestType} from '@esgi/core/enums';
import {CloseIcon, Modal, ModalBody, ModalFooter, ModalHeader, ModalManagerRef, Title} from '@esgi/deprecated/ui-kit/modal';
import styles from './test-type-selector.module.less';

interface Props {
	onSelected: (type: TestType) => void;
	onClose: () => void;
}

export default class TestTypeSelector extends React.PureComponent<Props> {
	private modalManagerRef: ModalManagerRef = createRef();

	public render(): ReactNode {
		return <Modal modalManagerRef={this.modalManagerRef}>
			<ModalHeader>
				<Title>Create New Test</Title>
				<CloseIcon className={styles.closeIcon} onClick={() => this.modalManagerRef.current.close(this.props.onClose)}/>
			</ModalHeader>
			<ModalBody className={styles.modalBody}>
				<div>
					<div className={styles.subHeader}>Begin by Selecting Your Test Type:</div>
					<div className={styles.cards}>
						{this.renderYesNoCard()}
						{this.renderSingleScore()}
						{this.renderRubricCard()}
					</div>
				</div>
			</ModalBody>
			<ModalFooter/>
		</Modal>;
	}

	private renderYesNoCard(): ReactNode {
		return <div className={styles.card} data-cy='test-type-card' id='yes-no-creating-button' onClick={(e => this.modalManagerRef.current.close(() => this.props.onSelected(TestType.YN)))}>
			<div className={styles.cardTitle}>
				Yes / No
			</div>
			<div className={styles.imageBlock}>
				<img className={styles.img} alt='YN'
				     src='//esgiwebfiles.s3.amazonaws.com/images/tests/creating/yn.png'/>
			</div>
			<div className={styles.description}>
				Tests contain multiple questions with correct (Yes) or incorrect (No) answers.
			</div>
		</div>;
	}

	private renderSingleScore(): ReactNode {
		return <div data-cy='test-type-card' className={styles.card} id='score-creating-button' onClick={(e => this.modalManagerRef.current.close(() => this.props.onSelected(TestType.Score)))}>
			<div className={styles.cardTitle}>
				Single Score
			</div>
			<div className={styles.imageBlock}>
				<img className={styles.img} alt='SS'
				     src='//esgiwebfiles.s3.amazonaws.com/images/tests/creating/ss.png'/>
				<div className={styles.ssSubTitle}>“Count to Five”</div>
			</div>
			<div className={styles.description}>
				Tests contain one question that receives a single score.
			</div>
		</div>;
	}

	private renderRubricCard(): ReactNode {
		return <div data-cy='test-type-card' className={styles.card} id='rubric-creating-button' onClick={(e => this.modalManagerRef.current.close(() => this.props.onSelected(TestType.Rubric)))}>
			<div className={styles.cardTitle}>
				Rubric
			</div>
			<div className={styles.imageBlock}>
				<img className={styles.img} alt='Rubric'
				     src='//esgiwebfiles.s3.amazonaws.com/images/tests/creating/rubric.png'/>
			</div>
			<div className={styles.description}>
				Set criteria and levels to measure student performance. Useful for observational assessments.
			</div>
		</div>;
	}
}
